export default __webpack_public_path__ + "static/media/searchIcon.89c0e299.svg";